export default class DatabaseFormDto {

    constructor(name: string | null) {
        this.Name = name;
    }

    Name: string | null;
}
